import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

// Generate or get session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('visitor_session_id');
  if (!sessionId) {
    sessionId = 'v_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
    sessionStorage.setItem('visitor_session_id', sessionId);
  }
  return sessionId;
};

// Page title map
const getPageTitle = (pathname) => {
  const titles = {
    '/': 'Home',
    '/products': 'Shop',
    '/cart': 'Shopping Cart',
    '/checkout': 'Checkout',
    '/account': 'My Account',
    '/orders': 'My Orders',
    '/login': 'Login',
    '/register': 'Register',
    '/contact': 'Contact Us',
    '/mini-owners-club': 'Ministripes Owners Forum',
    '/meet-mini-stripes': 'Meet Mini Stripes UK',
    '/stripes-application': 'Installing your Graphics',
    '/custom-sticker': 'Custom Sticker Designer',
    '/admin': 'Admin Panel',
  };
  
  // Check for product pages
  if (pathname.startsWith('/product/')) {
    return 'Product Details';
  }
  if (pathname.startsWith('/admin/')) {
    return 'Admin Panel';
  }
  
  return titles[pathname] || pathname;
};

export const useVisitorTracking = () => {
  const location = useLocation();
  const lastTrackedRef = useRef('');

  useEffect(() => {
    // Don't track admin pages
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    // Prevent duplicate tracking
    const currentPath = location.pathname + location.search;
    if (lastTrackedRef.current === currentPath) {
      return;
    }
    lastTrackedRef.current = currentPath;

    const trackPageView = async () => {
      try {
        const sessionId = getSessionId();
        const pageTitle = getPageTitle(location.pathname);
        
        await fetch(`${API}/api/analytics/track`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            session_id: sessionId,
            page: location.pathname,
            page_title: pageTitle,
            referrer: document.referrer || '',
            user_agent: navigator.userAgent
          }),
        });
      } catch (error) {
        // Silently fail - don't disrupt user experience
        console.debug('Analytics tracking failed:', error);
      }
    };

    // Small delay to ensure page has rendered
    const timeoutId = setTimeout(trackPageView, 100);
    
    return () => clearTimeout(timeoutId);
  }, [location.pathname, location.search]);
};

export default useVisitorTracking;
